/**
 * @module app.cm
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { apiCall } from 'app/shared/lib/essette-api';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { Toaster } from 'app/shared/lib/toaster';
import { CaseService } from 'app/cm/services/case-service';
import { CustomCareTeamParticipant } from 'app/cm/components/case/care-team/care-team-grid';

@autoinject()
export class AddComment extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView })
    protected caseId: string | null = null;

    @bindable.string({ defaultBindingMode: bindingMode.toView })
    protected commentText: string = '';

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected careTeamParticipants: ReadonlyArray<CustomCareTeamParticipant> = [];
    protected selectedCareTeamParticipants: CustomCareTeamParticipant[] = [];


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: CaseService,
        private readonly toaster: Toaster,
        ...rest: any[]) {

        super(...rest);
    }


    ////****************** Functions ************************************************////
    protected isThisUser: (participant: CustomCareTeamParticipant) => boolean =
        (participant: CustomCareTeamParticipant) => {
            return participant.assigned?.toUser?.id !== this.env.user.id;
        };

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public reset(): void {
        this.commentText = '';
        this.selectedCareTeamParticipants = [];
    }

    public async submit(): Promise<boolean> {
        return this.addComment();
    }

    protected buildComment(): any {
        const comment: any = {
            case: { id: this.caseId },
            text: this.commentText,
            mentions: this.selectedCareTeamParticipants.map(participant => {
                return { id: participant.id }
            } )
        };

        return comment;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async addComment(): Promise<boolean> {
        try {
            this.state.beginSave();

            const response = await this.service.addCareTeamComment(this.buildComment());
            this.toaster.standard.saved('cm:careTeam.comment.$', response.isSuccessful);
            return response.isSuccessful;
        }
        catch(error) {
            this.toaster.standard.saved('cm:careTeam.comment.$', false);
            throw error;
        }
        finally {
            this.state.endSave();
        }
    }
}
